import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import Paper from '@material-ui/core/Paper'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { LastWorkedOnDetails } from 'models/lastWorkedOnDetails'
import React from 'react'
import ReactResizeDetector from 'react-resize-detector'
import { Link } from 'react-router-dom'

const useLastWorkedOnItemBlockStyles = makeStyles((theme: Theme) => ({
    lastWorkedOnItemBlockPaper: {
        padding: theme.spacing(1, 2),
        textAlign: 'start',
    },
    nameText: {
        ...theme.typography.body1,
        color: '#0098D6',
    },
    levelText: {
        ...theme.typography.caption,
        color: theme.palette.grey[700],
    },
    nameLink: {
        textDecoration: 'none',
    },
}))

interface LastWorkedOnItemBlockProps {
    item: LastWorkedOnDetails
}

const LastWorkedOnItemBlock: React.FC<LastWorkedOnItemBlockProps> = ({
    item,
}) => {
    const classes = useLastWorkedOnItemBlockStyles()
    const [textWidth, setTextWidth] = React.useState(0)
    return (
        <Paper
            variant="elevation"
            elevation={0}
            className={classes.lastWorkedOnItemBlockPaper}
        >
            <Link
                to={`workspace/${item.elementId}`}
                className={classes.nameLink}
            >
                <TooltipEllipsis
                    text={item.name}
                    className={classes.nameText}
                    width={textWidth}
                >
                    {item.name}
                </TooltipEllipsis>
            </Link>
            <ReactResizeDetector
                handleHeight={false}
                handleWidth={true}
                onResize={(width: number) => setTextWidth(width)}
            />
            <Typography className={classes.levelText}>{item.level}</Typography>
        </Paper>
    )
}

export default LastWorkedOnItemBlock
